import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/pages/Home.vue';
import Group from '@/pages/Group.vue';
import Category from '@/pages/Category.vue';
import Product from '@/pages/Product.vue';
import Movie from '@/pages/Movie.vue';
import Search from '@/pages/Search.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: { title: 'イチオシ家具｜即納！イチオシ！WEB限定のおトク商品満載！' }
    },
    {
        // カテゴリーページのルーティング
        path: '/Category',
        // path: '/ichioshi/Product',
        name: 'Category',
        component: Category,
        // meta: { title: 'カテゴリー｜イチオシ家具'}
    },
    {
        // グループページのルーティング
        path: '/Group',
        // path: '/ichioshi/Group',
        name: 'Group',
        component: Group,
        // meta: { title: 'グループ｜イチオシ家具'}
    },
    {
        path: '/Product',
        // path: 'ichioshi/Detail',
        name: 'Product',
        component: Product,
        // meta: { title: '商品詳細｜イチオシ家具'}
    },
    {
        path: '/Movie',
        // path: 'ichioshi/Movie',
        name: 'Movie',
        component: Movie,
        // meta: { title: '動画｜イチオシ家具'}
    },
    {
        path: '/Search',
        // path: 'ichioshi/Movie',
        name: 'Search',
        component: Search,
        // meta: { title: '検索結果｜イチオシ家具'}
    }
]

const default_title = "イチオシ家具｜即納！イチオシ！WEB限定のおトク商品満載！"
const router = createRouter({
    // webサーバーにビルドするときは、”createWebHistory('/ichioshi/'),”に変更
    // history: createWebHistory(process.env.BASE_URL),
    history: createWebHistory('/contents/lp/ichioshi/'),

    // scrollBehavior: async (to, from, savedPosition) => {
    //     if(savedPosition) {
    //         return { savedPosition }
    //     }
    //     return { top: 0 }
    // },

    routes,
    base: './',

})

router.afterEach((to) => {
    document.title = to.meta.title || default_title
})

export default router